import { useEffect, useState } from "react";

const navLinks = [
  { label: "Home", href: "#home" },
  { label: "About", href: "#about" },
  { label: "Hospitality", href: "#hospitality" },
  { label: "Contact", href: "#contact" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur-md border-b border-background-200/70"
          : "bg-transparent"
      }`}
    >
      <nav className="flex items-center justify-between px-4 md:px-6 lg:px-10 h-16 md:h-20">
        <a href="#home" className="flex items-center gap-3 cursor-pointer">
          <span className="w-9 h-9 md:w-10 md:h-10 rounded-full bg-primary-500 flex items-center justify-center">
            <i className="ri-restaurant-2-line text-background-50 text-lg"></i>
          </span>
          <span className="leading-tight">
            <span
              className={`block font-heading text-lg md:text-xl font-semibold tracking-tight ${
                scrolled ? "text-foreground-950" : "text-background-50"
              }`}
            >
              RJB4
            </span>
            <span
              className={`block text-[0.6rem] md:text-[0.65rem] uppercase tracking-[0.28em] ${
                scrolled ? "text-foreground-500" : "text-background-50/80"
              }`}
            >
              Restaurant Group
            </span>
          </span>
        </a>

        <div className="hidden md:flex items-center gap-8 lg:gap-10">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className={`text-sm tracking-wide transition-colors duration-200 whitespace-nowrap cursor-pointer ${
                scrolled
                  ? "text-foreground-700 hover:text-primary-600"
                  : "text-background-50/90 hover:text-background-50"
              }`}
            >
              {link.label}
            </a>
          ))}
        </div>

        <div className="hidden md:block">
          <a
            href="#contact"
            className="inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium px-6 py-2.5 rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            Contact Us
          </a>
        </div>

        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          aria-label="Toggle navigation menu"
          className={`md:hidden w-10 h-10 flex items-center justify-center rounded-full cursor-pointer ${
            scrolled ? "text-foreground-900" : "text-background-50"
          }`}
        >
          <i className={`text-2xl ${open ? "ri-close-line" : "ri-menu-3-line"}`}></i>
        </button>
      </nav>

      {open && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70 px-4 pb-6 pt-2">
          <div className="flex flex-col">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setOpen(false)}
                className="py-3 text-foreground-800 font-medium border-b border-background-100 cursor-pointer"
              >
                {link.label}
              </a>
            ))}
            <a
              href="#contact"
              onClick={() => setOpen(false)}
              className="mt-4 inline-flex items-center justify-center gap-2 bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium px-6 py-3 rounded-full transition-colors cursor-pointer"
            >
              Contact Us
            </a>
          </div>
        </div>
      )}
    </header>
  );
}